export default class UrlHelper {
  /**
   * Ensures internal URLs start with a forward slash.
   * If the URL is external (starts with http, https, or //) it is returned as is.
   * If the URL is just a fragment (#) it is returned as is.
   * Otherwise, it ensures it starts with / and removes duplicate leading slashes.
   * 
   * @param {string} url - The URL to format
   * @returns {string} - The formatted URL
   */
  static formatInternalUrl(url) {
    if (!url) return '';
    
    // Check if it's an external URL or a fragment
    if (url.startsWith('http') || url.startsWith('//') || url.startsWith('mailto:') || url.startsWith('tel:') || url.startsWith('#')) {
      return url;
    }

    // Ensure it starts with /
    let formattedUrl = url.startsWith('/') ? url : `/${url}`;

    // Replace multiple leading slashes with a single one if they occur
    formattedUrl = formattedUrl.replace(/\/+/g, '/');

    return formattedUrl;
  }
}
